import { Observable, fromEvent, merge } from 'rxjs';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
export class BilNetworkService {
    constructor() { }
    createOnline$() {
        return merge(
        // offline event creation
        fromEvent(window, 'offline').pipe(map(() => false)), 
        // online event creation
        fromEvent(window, 'online').pipe(map(() => true)), 
        // value to observable to subscription
        new Observable((sub) => {
            sub.next(navigator.onLine);
            sub.complete();
        }));
    }
}
BilNetworkService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BilNetworkService_Factory() { return new BilNetworkService(); }, token: BilNetworkService, providedIn: "root" });
